//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { convertTime } from '../../components/helpers.js'
import { axiosGet, axiosPost } from '../../axios/axios.js'
import { EventBus } from '../../EventBus/EventBus.js'

import FuelingActSelectionDialog from '../CarWashAct/CarWashAndFuelingActSelectionDialog.vue'
import DateTimeField from '../../components/Field/DateTimeField.vue'
import FilesField from '../../components/File/FilesField.vue'
import FilesGroup from '../../components/File/FilesGroup.js'
import { journalRecordFilesGroups } from '../../components/File/JournalRecordFilesGroups.js'

export default {
  components: {
    FilesField,
    FuelingActSelectionDialog,
    DateTimeField
  },
  mixins: [journalRecordFilesGroups],
  props: {
    recordId: {
      type: Number,
      default: null
    },
    fuelingFinish: {
      type: Boolean,
      default: false
    },
    employeeFuelCards: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data: function () {
    return {
      record: {
        objectType: null,
        vehicle: null,
        vehicleType: null,
        odometerValue: null,
        fuelCard: {
          id: null,
          number: null
        },
        comment: null,

        id: null,
        name: null,
        stateId: null,
        stateName: null,
        time: null,
        visTransactionTime: null,
        changeTime: null,
        startFuelingTime: null,
        endFuelingTime: null,
        endFuelingTimeEmpty: true,
        employeeFIO: null,
        waybillId: null,
        waybillName: null,

        odometerPhoto: null,
        cashReceiptPhoto: null,
        returnReceiptPhoto: null,
        fuelingProcessPhoto: null,

        integrationActId: null,
        integrationActName: null,
        useIntegration: null,

        actOriginTypeCode: null,
        actOriginTypeName: null,
        actStatusName: null,
        actStatusCode: null,
        supplierName: null,
        supplierCode: null,

        fuelCost: null,
        fuelPrice: null,
        fuelType: {
          id: null,
          name: null
        },
        fuelVolume: null,
        fuelDiscount: null,
        servicePointId: null,
        adjustment: null
      },

      vehicles: [],
      fuelCards: [],
      integrationActs: [],
      adjustments: [],
      fuelTypes: [],
      refuels: [],
      optionsRefuels: [],

      fuelOpened: false,

      objectTypes: [
        { name: 'Транспортное средство', value: 'vehicle' },
        { name: 'Баллон', value: 'gasCan' },
        { name: 'Канистра', value: 'canister' }
      ],

      tempVehicle: null,
      showVehiclesTable: false,

      tempFuelCard: null,
      showFuelCardsTable: false,

      tempIntegrationAct: null,
      showIntegrationActs: false,

      tempWaybill: null,
      showWaybills: false,

      tempAdjustment: null,
      showAdjustments: false,

      convertTime: convertTime,

      loading: false,

      modalOpened: false,

      rules: {},

      paginationAdjustment: {
        page: 1,
        rowsPerPage: 0 // все строки
      },
      columnsAdjustment: [
        {
          name: 'date',
          label: 'Дата/время',
          align: 'left',
          field: 'date',
          sortable: true,
          format: convertTime
        },
        {
          name: 'fuelVolume',
          label: 'Количество',
          align: 'left',
          field: 'fuelVolume',
          sortable: true
        },
        {
          name: 'fuelCost',
          label: 'Сумма',
          align: 'left',
          field: 'fuelCost',
          sortable: true
        }
      ],

      // === Конфигурация групп файлов -> journalRecordFilesGroups
      documentUploadURL: '/service/delta/fuelingact/uploadphoto' // Override
    }
  },
  computed: {
    roleAdmin: function () {
      const user = this.$store.getters.getUser
      const roles = user.roles || {}
      return !!roles.root || !!roles.admin || !!roles.transportAdmin
    },
    integrationActEditable: function () {
      return this.record.useIntegration && (this.record.stateId !== 'FA3' || this.roleAdmin)
    },
    fuelCardEditable: function () {
      return this.record.stateId !== 'FA3' && this.record.actOriginTypeCode !== 'fuelSupplier' && this.record.actOriginTypeCode !== 'fuelSupplierAdjust'
    },
    vehicleEditable: function () {
      return this.record.stateId !== 'FA3'
    },
    waybillEditable: function () {
      return this.record.stateId !== 'FA3'
    }
  },
  watch: {
    '$route.params.id': {
      handler: function (value) {
        this.$q.loading.show({
          message: 'Обновление данных формы акта о заправке ТС...',
          messageColor: 'blue-11',
          spinnerColor: 'blue-11'
        })
        if (value && value !== 'create') {
          if (value != null) {
            this.load(value)
          } else {
            this.record.id = null
          }
        } else {
          this.prepareFilesGroups()
          this.$q.loading.hide()
        }
      },
      immediate: true
    },
    recordId: {
      handler: function (value) {
        if (value) {
          this.$q.loading.show({
            message: 'Обновление данных ...',
            messageColor: 'blue-11',
            spinnerColor: 'blue-11'
          })
          this.record.id = value
          if (value != null) {
            this.load()
          } else {
            this.$q.loading.hide()
            this.prepareFilesGroups()
          }
        }
      },
      immediate: true
    },
    'record.objectType': {
      handler: function (value) {
        if (!value) {
          this.record.vehicle = null
          this.record.odometerValue = null
        }
      },
      immediate: true
    }
  },
  created: function () {
    this.getFuelTypes()
    this.getRefuels()

    if (this.fuelingFinish) {
      this.getFuelCards('otherOnly')
    } else {
      this.getFuelCards('all')
    }
  },
  methods: {
    // Override
    getRecordId: function () {
      let recordId = this.recordId
      if (this.record && this.record.id) {
        recordId = this.record.id
      }
      return recordId || -1
    },
    //
    filterRefuels (val, update) {
      if (val === '') {
        update(() => {
          this.optionsRefuels = this.refuels
        })
        return
      }
      update(() => {
        const str = val.toLowerCase()
        this.optionsRefuels = this.refuels.filter((refuel) => {
          return refuel.name.toLowerCase().indexOf(str) > -1
        })
      })
    },
    onShowVehiclesTable: function () {
      this.getVehicles()
      this.tempVehicle = this.record.vehicle
      this.modalOpened = true
      this.showVehiclesTable = true
    },
    onVehicleSelected: function (vehicle) {
      this.tempVehicle = vehicle
    },
    onSaveVehicleSelection: function () {
      this.record.vehicle = this.tempVehicle
      this.record.odometerValue = +this.tempVehicle.odometerValue
      this.onCloseVehicleModal()
    },
    onCloseVehicleModal: function () {
      this.tempVehicle = null
      this.modalOpened = false
      this.showVehiclesTable = false
    },
    onShowFuelCardsTable: function () {
      if (this.record.actOriginTypeCode === 'fuelSupplier') {
        return
      }
      this.tempFuelCard = this.record.fuelCard
      this.modalOpened = true
      this.showFuelCardsTable = true
    },
    onFuelCardSelected: function (fuelCard) {
      this.tempFuelCard = fuelCard
    },
    onSaveFuelCardSelection: function () {
      this.record.fuelCard = this.tempFuelCard
      this.onCloseFuelCardModal()
    },
    onCloseFuelCardModal: function () {
      this.tempFuelCard = null
      this.modalOpened = false
      this.showFuelCardsTable = false
    },
    onShowIntegrationActs: function () {
      this.getIntegrationActs()
      this.tempIntegrationAct = { id: this.record.integrationActId, name: this.record.integrationActName }
      this.modalOpened = true
      this.showIntegrationActs = true
    },
    onIntegrationActSelected: function (act) {
      this.tempIntegrationAct = act
    },
    onDeleteIntegrationAct: function () {
      if (this.record.integrationActId) {
        this.$d_ask({
          callback: () => {
            this.save()
              .then(() => {
                this.record.integrationActId = null
                this.link()
              })
          },
          header: 'Удалить привязанный интеграционный акт о заправке топлива?'
        })
      }
    },
    onSaveIntegrationActSelection: function () {
      if (this.record.integrationActId !== this.tempIntegrationAct.id) {
        this.record.integrationActName = this.tempIntegrationAct.name
        this.record.integrationActId = this.tempIntegrationAct.id
        this.onCloseIntegrationActsModal()
        this.save()
          .then((res) => {
            this.link()
          })
          .catch((res) => {
            this.record.integrationActName = null
            this.record.integrationActId = null
          })
      } else {
        this.onCloseIntegrationActsModal()
      }
    },
    onCloseIntegrationActsModal: function () {
      this.tempIntegrationAct = null
      this.modalOpened = false
      this.showIntegrationActs = false
    },
    onShowWaybillsTable: function () {
      this.tempWaybill = { id: this.record.waybillId, name: this.record.waybillName }
      this.modalOpened = true
      this.showWaybills = true
    },
    onWaybillSelected: function (waybill) {
      this.tempWaybill = { id: waybill.id, name: waybill.name }
      this.getVehicleFromWaybill(waybill.vehicleId)
    },
    onSaveWaybillSelection: function () {
      this.record.waybillId = this.tempWaybill.id
      this.record.waybillName = this.tempWaybill.name
      this.onCloseWaybillsModal()
      this.record.vehicle = this.tempVehicle
      this.tempVehicle = null
    },
    onCloseWaybillsModal: function () {
      this.tempWaybill = null
      this.modalOpened = false
      this.showWaybills = false
    },
    getVehicleFromWaybill: function (vehicleId) {
      axiosGet({
        url: 'service/delta/vehicle/get?id=' + vehicleId,
        onSuccess: (response) => {
          const result = response.data
          this.tempVehicle = result
        }
      })
    },
    onShowAdjustments: function (data) {
      this.getAdjustments()
      this.modalOpened = true
      this.showAdjustments = true
    },
    onAdjustmentSelected: function (adjustment) {
      this.tempAdjustment = adjustment
    },
    onDeleteAdjustment: function (data) {
      if (data.id) {
        this.$d_ask({
          callback: () => {
            this.linkAdjustment(this.record.id, data.id, false)
          },
          header: 'Удалить корректировку?'
        })
      }
    },
    onSaveAdjustmentSelection: function () {
      if (this.tempAdjustment && !this.record.adjustment.map(ad => ad.id).includes(this.tempAdjustment.id)) {
        this.$d_ask({
          callback: () => {
            this.linkAdjustment(this.record.id, this.tempAdjustment.id, true)
            this.onCloseAdjustmentsModal()
          },
          header: 'Добавить корректировку?'
        })
      } else {
        this.onCloseAdjustmentsModal()
      }
    },
    onCloseAdjustmentsModal: function () {
      this.tempAdjustment = null
      this.modalOpened = false
      this.showAdjustments = false
    },
    onRemoveWaybill: function (id) {
      this.$d_ask({
        callback: () => {
          this.removeWaybill(id)
        },
        header: 'Удалить рейс?'
      })
    },
    removeWaybill: function (id) {
      this.loading = true

      const bodyFormData = new FormData()
      bodyFormData.set('id', id)

      axiosPost({
        url: '/service/delta/fuelingact/removeWaybill',
        data: bodyFormData,
        onSuccess: (response) => {
          this.load()
        },
        onFailure: 'Ошибка удаления акта',
        msgTarget: this
      }).finally(() => {
        this.loading = false
      })
    },
    close: function () {
      if (this.fuelingFinish) {
        this.$emit('close')
      } else {
        if (window.history.length != 1 && window.history.state !== null) {
          this.$router.back()
        } else {
          this.$router.push('/')
        }
      }
    },
    save: function () {
      const validPhotosMessages = this.getFilesGroupsValidationMessages()
      const validFields = []
      if (this.$refs.startFuelingTime && !this.$refs.startFuelingTime.validate()) {
        validFields.push(this.$refs.startFuelingTime.label.charAt(0).toUpperCase() + this.$refs.startFuelingTime.label.slice(1).toLowerCase())
      }
      if (this.$refs.endFuelingTime && !this.$refs.endFuelingTime.validate() && !this.record.endFuelingTime) {
        validFields.push(this.$refs.endFuelingTime.label.charAt(0).toUpperCase() + this.$refs.endFuelingTime.label.slice(1).toLowerCase())
      }
      if (this.$refs.objectType && !this.$refs.objectType.validate()) {
        validFields.push(this.$refs.objectType.label.charAt(0).toUpperCase() + this.$refs.objectType.label.slice(1).toLowerCase())
      }
      if (this.$refs.vehicle && !this.$refs.vehicle.validate()) {
        validFields.push(this.$refs.vehicle.label.charAt(0).toUpperCase() + this.$refs.vehicle.label.slice(1).toLowerCase())
      }
      if (this.$refs.fuelCard && !this.$refs.fuelCard.validate()) {
        validFields.push(this.$refs.fuelCard.label.charAt(0).toUpperCase() + this.$refs.fuelCard.label.slice(1).toLowerCase())
      }
      if (this.$refs.waybillName && !this.$refs.waybillName.validate()) {
        validFields.push(this.$refs.waybillName.label.charAt(0).toUpperCase() + this.$refs.waybillName.label.slice(1).toLowerCase())
      }

      const validTimes = (this.$refs.endFuelingTime && this.$refs.endFuelingTime.validate()) || !this.record.endFuelingTime

      if (validPhotosMessages.length === 0 && validFields.length === 0 && validTimes) {
        return this.addRecord()
      } else {
        let message = ''
        if (validFields.length > 0) {
          message += 'Не заполнены обязательные поля: ' + validFields.map(val => '"' + val + '"').join(', ') + '.\n'
        }
        if (validPhotosMessages.length > 0) {
          message += 'Не прикреплены фотографии ' + validPhotosMessages.join(', ') + '.\n'
        }
        if (!validTimes) {
          message += 'Дата/время завершения заправки не может быть раньше времени начала.'
        }

        this.$q.notify({
          type: 'negative',
          message: message,
          progress: true,
          timeout: 30000
        })

        return Promise.reject(Error('Не заполнены обязательные поля'))
      }
    },
    uploadFilesAct: async function (id) {
      const oldId = this.record.id
      this.record.id = id
      return this.uploadFiles()
        .then(result => {
          if (result) {
            const validPhotosMessages = this.getFilesGroupsValidationMessages(true)
            if (result.status !== 'positive' || validPhotosMessages.length !== 0) {
              return Promise.reject(Error())
            }
            if (!oldId) {
              this.load()
            }
          }
        }).catch(result => {
          if (result.message) {
            this.$q.notify({
              type: 'negative',
              message: result.message,
              progress: true,
              timeout: 8000
            })
          }
          return Promise.reject(Error())
        })
    },
    addRecord: async function () {
      this.$q.loading.show({
        message: 'Изменение данных формы акта...',
        messageColor: 'blue-11',
        spinnerColor: 'blue-11'
      })

      const bodyFormData = new FormData()
      if (this.record.id) {
        try {
          await this.uploadFilesAct(this.record.id)
        } catch (error) {
          this.$q.loading.hide()
          return Promise.reject(Error('Ошибка сохранения файлов'))
        }

        bodyFormData.set('id', this.record.id)
      }

      bodyFormData.set('objectType', this.record.objectType)

      if (this.fuelingFinish && this.record.vehicleId) {
        bodyFormData.set('vehicle', this.record.vehicleId)
      } else if (this.record.vehicle && this.record.vehicle.id) {
        bodyFormData.set('vehicle', this.record.vehicle.id)
      }

      if (this.record.odometerValue) {
        bodyFormData.set('odometerValue', +this.record.odometerValue)
      }
      if (this.record.fuelCard && this.record.fuelCard.id) {
        bodyFormData.set('fuelCardId ', this.record.fuelCard.id)
      }

      if (this.record.comment) {
        bodyFormData.set('comment', this.record.comment)
      }

      if (this.fuelingFinish || this.record.endFuelingTimeEmpty) {
        bodyFormData.set('finishFueling', true)
      }

      if (this.record.waybillId) {
        bodyFormData.set('waybill', this.record.waybillId)
      }

      if (this.record.useIntegration !== null) {
        bodyFormData.set('useIntegration', this.record.useIntegration)
      }

      if (this.record.servicePointId) {
        bodyFormData.set('servicePointId', this.record.servicePointId)
      }

      if (!this.record.id && this.record.startFuelingTime) {
        bodyFormData.set('startFuelingTime', this.record.startFuelingTime)
      }
      if (this.record.endFuelingTime) {
        bodyFormData.set('endFuelingTime', this.record.endFuelingTime)
      }

      if (!this.record.useIntegration) {
        if (this.record.fuelType && this.record.fuelType.id) {
          bodyFormData.set('fuelTypeId', this.record.fuelType.id)
        }
        if (this.record.fuelPrice) {
          bodyFormData.set('fuelPrice', this.record.fuelPrice)
        }
        if (this.record.fuelCost) {
          bodyFormData.set('fuelCost', this.record.fuelCost)
        }
        if (this.record.fuelVolume) {
          bodyFormData.set('fuelVolume', +this.record.fuelVolume)
        }
        if (this.record.fuelDiscount) {
          bodyFormData.set('discount', this.record.fuelDiscount)
        }
      }

      return axiosPost({
        url: 'service/delta/fuelingact/save',
        data: bodyFormData,
        onSuccess: async (response) => {
          this.$q.notify({
            type: 'positive',
            message: 'Успешное сохранения акта',
            progress: true,
            timeout: 3000
          })

          if (this.record.id === null) {
            try {
              await this.uploadFilesAct(response.data.id)
            } finally {
              this.$router.replace('/transport/fuelingAct/' + response.data.id)
              EventBus.$emit('update-fuelingAct', {})
            }
          } else {
            if (this.fuelingFinish) {
              this.$emit('fueling-act-finished')
              this.close()
            } else {
              this.load()
              EventBus.$emit('update-fuelingAct', {})
            }
          }

          return Promise.resolve(response)
        },
        onFailure: (response) => {
          this.$q.loading.hide()
          this.$q.notify({
            type: 'negative',
            message: response.message ? response.message : 'Ошибка сохранения акта',
            progress: true,
            timeout: 8000
          })
          return Promise.reject(Error('Ошибка сохранения акта'))
        },
        msgTarget: this
      })
        .finally(() => this.$q.loading.hide())
    },
    FA03_Ready: function () {
      this.save().then(() => {
        this.loading = true

        const bodyFormData = new FormData()
        bodyFormData.set('objectId', this.record.id)

        axiosPost({
          url: '/service/delta/fuelingact/' + 'FA3',
          data: bodyFormData,
          onSuccess: async (response) => {
            this.$q.notify({
              type: 'positive',
              message: 'Успешная установка состояния готовности акта',
              progress: true,
              timeout: 3000
            })

            await this.load()
            EventBus.$emit('update-fuelingAct', {})
          },
          onFailure: 'Ошибка установки состояния готовности акта',
          msgTarget: this
        })
          .finally(() => {
            this.loading = false
          })
      })
    },
    FA04_Cancel: function () {
      this.$d_ask({
        callback: () => {
          this.loading = true

          const bodyFormData = new FormData()
          bodyFormData.set('objectId', this.record.id)

          axiosPost({
            url: '/service/delta/fuelingact/' + 'FA4',
            data: bodyFormData,
            onSuccess: (response) => {
              this.$q.notify({
                type: 'positive',
                message: 'Успешное аннулирование акта',
                progress: true,
                timeout: 3000
              })

              EventBus.$emit('update-fuelingAct', {})
              this.close()
            },
            onFailure: 'Ошибка аннулирования записи журнала',
            msgTarget: this
          })
            .finally(() => {
              this.loading = false
            })
        },
        header: 'Аннулировать акт о заправке топлива?'
      })
    },
    load: function (recordId = this.record.id) {
      this.loading = true
      return axiosGet({
        url: 'service/delta/fuelingact/get?id=' + recordId,
        onSuccess: (response) => {
          const result = response.data.result
          const record = this.record
          if (result.id) {
            record.id = result.id
          }
          record.name = result.name
          record.objectType = result.refuelingObjectType
          record.comment = result.comment ? result.comment.comment : null
          record.stateId = result.stateId
          record.stateName = result.stateName
          record.time = result.time
          record.visTransactionTime = result.visTransactionTime
          record.changeTime = result.changeTime
          record.startFuelingTime = result.startFuelingTime
          if (result.endFuelingTime) {
            record.endFuelingTime = result.endFuelingTime
            this.record.endFuelingTimeEmpty = false
          }
          record.employeeFIO = result.employeeFIO
          record.fuelVolume = result.fuelVolume
          record.odometerValue = result.odometerValue
          record.useIntegration = result.useIntegration
          record.waybillId = result.waybillId
          record.waybillName = result.waybillName

          if (this.fuelingFinish) {
            this.$emit('update-list-fuelcard')
            if (!result.fuelCard && this.employeeFuelCards.length === 1) {
              this.record.fuelCard = this.employeeFuelCards[0]
            } else {
              this.record.fuelCard = result.fuelCard
            }

            record.vehicleId = result.vehicleId
            record.vehicleName = result.vehicleName
            const objT = this.objectTypes.filter(function (element) {
              return element.value == result.refuelingObjectType
            })
            record.refuelingObjectTypeName = objT ? objT[0].name : ''

            if (result.vehicleId) {
              this.getOdometerValue(result.vehicleId)
            }

            if (record.id) {
              axiosGet({
                url: '/service/delta/fuelingact/nearestRefuel?id=' + record.id,
                onSuccess: (response) => {
                  if (response.data && response.data.result) {
                    record.servicePointId = response.data.result.id
                  }
                },
                onFailure: 'Ошибка загрузки информации по ближайшей АЗК',
                msgTarget: this
              })
            }
          } else {
            record.fuelCard = result.fuelCard

            record.vehicle = {
              id: result.vehicleId,
              model: result.vehicleModel,
              gosNumber: result.gosNumber,
              name: result.vehicleName
            }

            record.integrationActId = result.integrationActId
            record.integrationActName = result.integrationActName

            record.actOriginTypeCode = result.actOriginTypeCode
            record.actOriginTypeName = result.actOriginTypeName
            record.actStatusName = result.actStatusName
            record.actStatusCode = result.actStatusCode
            record.supplierName = result.supplierName
            record.supplierCode = result.supplierCode

            record.fuelCost = result.fuelCost
            record.fuelPrice = result.fuelPrice
            if (result.fuelType) {
              record.fuelType = result.fuelType
            }
            record.fuelVolume = result.fuelVolume
            record.fuelDiscount = result.fuelDiscount
            record.servicePointId = result.servicePointId
            record.adjustment = result.adjustment

            if (record.adjustment) {
              let newFuelCost = record.fuelCost
              let newFuelVolume = record.fuelVolume

              for (let i = 0; i < record.adjustment.length; i++) {
                if (record.adjustment[i].fuelCost) {
                  newFuelCost += record.adjustment[i].fuelCost
                }
                if (record.adjustment[i].fuelVolume) {
                  newFuelVolume += record.adjustment[i].fuelVolume
                }
              }

              if (newFuelCost !== record.fuelCost && record.fuelCost) {
                newFuelCost = Math.round(newFuelCost * 100) / 100
                record.fuelCost = newFuelCost + ' (без учёта корректировки ' + record.fuelCost + ')'
              }
              if (newFuelVolume !== record.fuelVolume && record.fuelVolume) {
                newFuelVolume = Math.round(newFuelVolume * 100) / 100
                record.fuelVolume = newFuelVolume + ' (без учёта корректировки ' + record.fuelVolume + ')'
              }
            }
          }

          record.odometerPhoto = result.odometerPhoto
          record.cashReceiptPhoto = result.cashReceiptPhoto
          record.returnReceiptPhoto = result.returnReceiptPhoto
          record.fuelingProcessPhoto = result.fuelingProcessPhoto
          this.prepareFilesGroups()
        },
        onFailure: 'Ошибка загрузки акта о заправке топлива',
        msgTarget: this
      }).finally(() => {
        this.$q.loading.hide()
        if (this.record.actStatusCode === 'manual' || this.record.actStatusCode === 'auto' || this.record.actOriginTypeCode === 'fuelSupplier') {
          this.fuelOpened = true
        }
        if (this.fuelingFinish) {
          this.getFilesGroupsValidationMessages()
          if (this.$refs.fuelCard) {
            this.$refs.fuelCard.validate()
          }
        }
        this.loading = false
      })
    },
    prepareFilesGroups: function () {
      this.clearFilesGroups()
      if (this.record) {
        const date = this.record.startFuelingTime
        const readOnly = false // this.fuelingFinish ? - TODO проверка доступа
        const partTitle = 'ФОТО' + (readOnly ? '' : 'ГРАФИЯ')
        const listFilesGroup = {
          odometerPhoto: { title: partTitle + ' ОДОМЕТРА', documentType: 'odometer', props: { required: false, validationMessage: 'одометра' } },
          cashReceiptPhoto: { title: partTitle + ' КАССОВОГО ЧЕКА ЗАПРАВКИ', documentType: 'cashReceipt', props: { required: true, validationMessage: 'кассового чека заправки' } },
          returnReceiptPhoto: { title: partTitle + ' КАССОВОГО ЧЕКА ВОЗВРАТА', documentType: 'returnReceipt', props: { required: false, validationMessage: 'кассового чека возврата' } },
          fuelingProcessPhoto: { title: partTitle + ' ПРОЦЕССА ЗАПРАВКИ', documentType: 'fuelingProcess', props: { required: false, validationMessage: 'процесса заправки' } }
        }
        if (!this.record.imagesFilesGroup) {
          this.$set(this.record, 'imagesFilesGroup', {})
        }
        Object.keys(listFilesGroup).forEach(key => {
          if (this.record.imagesFilesGroup[key] === undefined) {
            this.$set(this.record.imagesFilesGroup, key, new FilesGroup({
              key: key,
              categoryKey: key,
              title: listFilesGroup[key].title,
              readonly: readOnly,
              documentType: listFilesGroup[key].documentType,
              props: { required: listFilesGroup[key].props.required, validationMessage: listFilesGroup[key].props.validationMessage, collapseId: key + '_collapse' }
            }))
            this.filesGroups.push(this.record.imagesFilesGroup[key])
          }
          if (this.record[key] && this.record[key].id) {
            const id = this.record[key].id
            this.record.imagesFilesGroup[key].pushFile({
              id: id,
              name: 'Фотография ' + listFilesGroup[key].props.validationMessage + '_' + date
            })
          }
        })
        this.getFilesGroupsValidationMessages()
        this.loadPreloadedFiles()
      }
    },
    link: function () {
      this.loading = true
      const bodyFormData = new FormData()

      let operationMessage = 'удаление интеграционного акта'
      bodyFormData.set('id1', this.record.id)

      if (this.record.integrationActId) {
        operationMessage = 'связывание интеграционных актов'
        bodyFormData.set('id2', this.record.integrationActId)
      }

      axiosPost({
        url: '/service/delta/fuelingact/link',
        data: bodyFormData,
        onSuccess: (response) => {
          this.$q.notify({
            type: 'positive',
            message: 'Успешное ' + operationMessage,
            progress: true,
            timeout: 3000
          })
        },
        onFailure: 'Ошибка ' + operationMessage,
        msgTarget: this
      })
        .finally(() => {
          this.load()
          this.loading = false
        })
    },
    linkAdjustment: function (actId, adjustmentId, add) {
      this.loading = true
      const bodyFormData = new FormData()

      bodyFormData.set('id1', actId)
      bodyFormData.set('id2', adjustmentId)
      bodyFormData.set('add', add)

      axiosPost({
        url: '/service/delta/fuelingact/adjustment',
        data: bodyFormData,
        onSuccess: (response) => {
          this.$q.notify({
            type: 'positive',
            message: 'Успешное редактирование корректировок',
            progress: true,
            timeout: 3000
          })
          this.load()
        },
        onFailure: 'Ошибка добавления корректировки',
        msgTarget: this
      })
        .finally(() => {
          this.loading = false
        })
    },
    getVehicles: function () {
      this.loading = true

      axiosGet({
        url: 'service/delta/vehicle/list',
        onSuccess: (response) => {
          this.vehicles = response.data
        },
        onFailure: 'Ошибка загрузки списка доступных транспортных средств',
        msgTarget: this
      })
        .finally(() => {
          this.loading = false
        })
    },
    getFuelCards: function (owningMode) {
      this.loading = true

      axiosGet({
        url: '/service/delta/fuelCard/list?owningMode=' + owningMode,
        onSuccess: (response) => {
          response.data.result.sort((a, b) => {
            if (a.order && b.order) {
              return a.order - b.order
            } else if (a.order) {
              return -1
            } else if (b.order) {
              return 1
            } else {
              return String(a.number).localeCompare(b.number)
            }
          })

          const allFuelCards = response.data.result
          if (this.fuelingFinish) {
            this.fuelCards = []
            if (this.employeeFuelCards && this.employeeFuelCards.length) {
              this.fuelCards.push({ key: 'personal', name: 'Свои топливные карты', children: this.employeeFuelCards })
            }
            if (allFuelCards && allFuelCards.length) {
              this.fuelCards.push({ key: 'other', name: 'Чужие топливные карты', children: allFuelCards }
              )
            }
          } else {
            this.fuelCards = allFuelCards
          }
        },
        onFailure: 'Ошибка загрузки списка чужих топливных карт',
        msgTarget: this
      })
        .finally(() => {
          this.loading = false
        })
    },
    getIntegrationActs: function () {
      this.loading = true
      const params = [
        { param: 'actOriginType', type: 'listvalue', action: '=', value: 'fuelSupplier' },
        { param: 'actStatus', type: 'listvalue', action: '=', value: 'undefined' },
        { param: 'fuelCardNumber', type: 'string', action: 'any' },
        { param: 'fuelVolume', type: 'double', action: 'any' },
        { param: 'servicePointAddress', type: 'string', action: 'any' },
        { param: 'visTransactionDate', type: 'datetime', action: '>', value: this.record.startFuelingTime - 60 * 60 * 1000 },
        { param: 'visTransactionDate', type: 'datetime', action: '<', value: this.record.endFuelingTime ? this.record.endFuelingTime : this.record.startFuelingTime + 60 * 60 * 1000 }
      ]
      const encodeParams = encodeURI(JSON.stringify(params))
      axiosGet({
        url: '/service/obj/search?params=' + encodeParams + '&nameField=name&paramsOperation=and&type=fuelingAct&subtypes=true&start=0&limit=5000&sort=createtime&dir=DESC',
        onSuccess: (response) => {
          this.integrationActs = response.data.result
        },
        onFailure: 'Ошибка загрузки интеграционных актов',
        msgTarget: this
      })
        .finally(() => {
          this.loading = false
        })
    },
    getAdjustments: function () {
      this.loading = true
      const params = [
        { param: 'actOriginType', type: 'listvalue', action: '=', value: 'fuelSupplierAdjust' },
        { param: 'actStatus', type: 'listvalue', action: '=', value: 'undefined' },
        { param: 'visTransactionDate', type: 'datetime', action: 'any' },
        { param: 'fuelType', type: 'number', action: 'any' },
        { param: 'fuelVolume', type: 'number', action: 'any' },
        { param: 'fuelPrice', type: 'number', action: 'any' },
        { param: 'fuelCost', type: 'number', action: 'any' },
        { param: 'fuelCardNumber', type: 'string', action: 'any' }
      ]
      const encodeParams = encodeURI(JSON.stringify(params))
      axiosGet({
        url: '/service/obj/search?params=' + encodeParams + '&nameField=name&paramsOperation=and&type=fuelingAct&subtypes=true&start=0&limit=5000&sort=createtime&dir=DESC',
        onSuccess: (response) => {
          this.adjustments = response.data.result
        },
        onFailure: 'Ошибка загрузки интеграционных актов',
        msgTarget: this
      })
        .finally(() => {
          this.loading = false
        })
    },
    getRefuels: function () {
      this.loading = true

      const params = [{ param: 'isActual', type: 'boolean', action: '=', value: true }]
      const encodeParams = encodeURIComponent(JSON.stringify(params))
      axiosGet({
        url: '/service/obj/search?params=' + encodeParams + '&nameField=name&paramsOperation=and&type=refuel&subtypes=true&start=0&limit=5000&sort=param.order&dir=ASC',
        onSuccess: (response) => {
          this.refuels = response.data.result
          this.optionsRefuels = this.refuels
        },
        onFailure: 'Ошибка загрузки заправок',
        msgTarget: this
      })
        .finally(() => {
          this.loading = false
        })
    },
    getFuelTypes: function () {
      this.loading = true
      axiosGet({
        url: '/service/obj/search?nameField=name&paramsOperation=and&type=fuelType&subtypes=true&start=0&limit=10000&dir=DESC',
        onSuccess: (response) => {
          this.fuelTypes = response.data.result
        },
        onFailure: 'Ошибка загрузки типов топлива',
        msgTarget: this
      })
        .finally(() => {
          this.loading = false
        })
    },
    getOdometerValue: function (vehicleId) {
      this.loading = true
      axiosGet({
        url: '/service/delta/vehicle/get?id=' + vehicleId,
        onSuccess: (response) => {
          const vehicle = response.data
          this.record.odometerValue = +vehicle.odometerValue
        },
        onFailure: 'Ошибка загрузки информации по транспортному средству',
        msgTarget: this
      })
        .finally(() => {
          this.loading = false
        })
    },
    onOpenWaybill: function () {
      if (this.record.waybillId) {
        this.$router.push('/transport/waybill/' + this.record.waybillId)
      }
    },
    getColorState: function () {
      let color = ''
      if (this.record && this.record.actOriginTypeCode !== 'serviceSupplier') {
        const stateId = this.record.stateId
        switch (stateId) {
          case 'FA3':
            color = 'green-11'
            break
          case 'FA4':
            color = 'red-2'
            break
          default:
            color = this.record.actStatusCode === 'undefined' ? 'red-2' : 'lime-2'
            break
        }
      }
      return color
    },
    getParamsSelection: function () {
      const params = {
        items: [],
        itemsForm: [],
        selectedItem: null,
        type: 'default'
      }
      let itemsForm = []
      if (this.showVehiclesTable) {
        let recordVehicle = 'Не выбрано'
        let tempVehicle = 'Не выбрано'
        if (this.record && this.record.vehicle) {
          recordVehicle = (this.record.vehicle.name ? this.record.vehicle.name + ' ' : '')
          recordVehicle += this.record.vehicle.model + ' ' + this.record.vehicle.gosNumber
        }
        if (this.tempVehicle) {
          tempVehicle = this.tempVehicle.name + ' ' + this.tempVehicle.model + ' ' + this.tempVehicle.gosNumber
        }
        itemsForm = [
          { key: 'vehicle', name: 'Транспортное средство в записи журнала', value: recordVehicle, show: recordVehicle !== 'Не выбрано' },
          { key: 'tempVehicle', name: 'Текущее выбранное транспортное средство', value: tempVehicle, show: true }
        ]
        this.$set(params, 'items', this.vehicles)
        this.$set(params, 'itemsForm', itemsForm)
        this.$set(params, 'selectedItem', this.record ? this.record.vehicle : null)
        this.$set(params, 'type', 'showVehiclesTable')
        this.$set(params, 'title', 'Выбор транспортного средства')
      } else if (this.showFuelCardsTable) {
        let recordCard = 'Не выбрана'
        let tempCard = 'Не выбрана'
        if (this.record && this.record.fuelCard) {
          recordCard = this.record.fuelCard.number
        }
        if (this.tempFuelCard) {
          tempCard = this.tempFuelCard.number
        }
        itemsForm = [
          { key: 'card', name: 'Карта в записи журнала', value: recordCard, show: recordCard !== 'Не выбрана' },
          { key: 'tempCard', name: 'Текущая выбранная карта', value: tempCard, show: true }
        ]
        this.$set(params, 'items', this.fuelCards)
        this.$set(params, 'itemsForm', itemsForm)
        this.$set(params, 'selectedItem', this.record && this.record.fuelCard ? this.record.fuelCard : null)
        this.$set(params, 'type', 'showFuelCardsTable')
        this.$set(params, 'title', 'Выбор карты')
      } else if (this.showIntegrationActs) {
        let tempIntegrationAct = 'Не выбран'
        if (this.tempIntegrationAct) {
          tempIntegrationAct = this.tempIntegrationAct.name
        }
        itemsForm = [
          { key: 'tempIntegrationAct', name: 'Выбранный акт', value: tempIntegrationAct, show: true }
        ]
        this.$set(params, 'items', this.integrationActs)
        this.$set(params, 'itemsForm', itemsForm)
        this.$set(params, 'selectedItem', this.tempIntegrationAct)
        this.$set(params, 'type', 'showIntegrationActs')
        this.$set(params, 'title', 'Выбор интеграционного акта')
      } else if (this.showWaybills) {
        let tempWaybill = 'Не выбран'
        if (this.tempWaybill && this.tempWaybill.name) {
          tempWaybill = this.tempWaybill.name
        }
        itemsForm = [
          { key: 'tempWaybill', name: 'ТЕКУЩИЙ ВЫБРАННЫЙ РЕЙС:', value: tempWaybill, show: true }
        ]
        this.$set(params, 'items', [])
        this.$set(params, 'itemsForm', itemsForm)
        this.$set(params, 'selectedItem', this.tempWaybill ? this.tempWaybill : null)
        this.$set(params, 'type', 'showWaybills')
      } else if (this.showAdjustments) {
        let tempAdjustment = 'Не выбран'
        if (this.tempAdjustment && this.tempAdjustment.name) {
          tempAdjustment = this.tempAdjustment.name
        }
        itemsForm = [
          { key: 'tempAdjustment', name: 'ВЫБРАННАЯ КОРРЕКТИРОВКА:', value: tempAdjustment, show: true }
        ]
        this.$set(params, 'items', this.adjustments)
        this.$set(params, 'itemsForm', itemsForm)
        this.$set(params, 'selectedItem', this.tempAdjustment ? this.tempAdjustment : null)
        this.$set(params, 'type', 'showAdjustments')
      }
      return params
    },
    onSaveSelection: function (type) {
      switch (type) {
        case 'showVehiclesTable':
          this.onSaveVehicleSelection()
          break
        case 'showFuelCardsTable':
          this.onSaveFuelCardSelection()
          break
        case 'showIntegrationActs':
          this.onSaveIntegrationActSelection()
          break
        case 'showWaybills':
          this.onSaveWaybillSelection()
          break
        case 'showAdjustments':
          this.onSaveAdjustmentSelection()
          break
        default:
          break
      }
    },
    onCloseSelection: function (type) {
      switch (type) {
        case 'showVehiclesTable':
          this.onCloseVehicleModal()
          break
        case 'showFuelCardsTable':
          this.onCloseFuelCardModal()
          break
        case 'showIntegrationActs':
          this.onCloseIntegrationActsModal()
          break
        case 'showWaybills':
          this.onCloseWaybillsModal()
          break
        case 'showAdjustments':
          this.onCloseAdjustmentsModal()
          break
        default:
          break
      }
    },
    onSelectedItem: function (params) {
      switch (params.type) {
        case 'showVehiclesTable':
          this.onVehicleSelected(params.selectedItem)
          break
        case 'showFuelCardsTable':
          this.onFuelCardSelected(params.selectedItem)
          break
        case 'showIntegrationActs':
          this.onIntegrationActSelected(params.selectedItem)
          break
        case 'showWaybills':
          this.onWaybillSelected(params.selectedItem)
          break
        case 'showAdjustments':
          this.onAdjustmentSelected(params.selectedItem)
          break
        default:
          break
      }
    }
  }
}

